export default "__VITE_ASSET__Bmg2o2us__"